import PropTypes from "prop-types";
import styles from "./MediaButton.module.css";
import playIcon from "../../assets/Play_Icon.svg";

/**
 * Interactive component, a button that displays a video or plays an audio when clicked.
 */
export function MediaButton({ isModalOpen, setIsModalOpen, mediaSettings }) {
  const hasVzaarId = mediaSettings && mediaSettings.vzaarId;

  return (
    <div>
      {hasVzaarId && (
        <div className={styles.mediaButton} onClick={setIsModalOpen}>
          <img src={playIcon} alt="Play Icon" />
        </div>
      )}
    </div>
  );
}

MediaButton.propTypes = {
  isModalOpen: PropTypes.bool,
  setIsModalOpen: PropTypes.func,
  mediaSettings: PropTypes.shape({
    vzaarId: PropTypes.string,
    format: PropTypes.oneOf(["Video", "Audio"]),
  }),
};
